import React, { Component } from 'react';
import { connect } from 'react-redux';
import MiniSpinner from '../../General/MiniSpinner';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import { limpiarLiquidacionesBusqueda, fetchEstadosLiquidacionesCorrecto, fetchEstadosLiquidaciones, fetchLiquidacionesBusqueda, fetchLiquidacionesBusquedaDirecto } from '../../../actions/LiquidacionesActions';
import { customStyleFilter, DropDownArrow, filterSelectMenuPortalProps } from "../../../template/CustomStyle";
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import { exportToExcel } from '../../../components/General/Excel/ExcelExportHelper';
import '../Exportables.css';

class ExportarLiquidaciones extends Component {

  constructor(props) {
    super(props);
    this.state = {
      request: null,
      datosExcelFormateados: null,
      estadoCheckbox: false,
      hideSpinner: true,
      // sellers se cargan desde redux como en Órdenes/Publicaciones
      lista_estados_liquidaciones: [],
      lista_liquidaciones_busqueda: [],
      comboLiquidacionSeller: { label: "", value: "" },
      comboLiquidacionEstado: { label: "", value: "" },
      fechaDesde: "",
      fechaDesdePredeterminado: "",
      fechaHasta: "",
      fechaHastaPredeterminado: "",
      elements: ""
    }
  };

  myChangeHandler = async (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  }

  busquedaParaDescargarExcel = () => {

    if (this.state.estadoCheckbox === true) {

      this.setState({ hideSpinner: false });

      this.props.fetchLiquidacionesBusqueda();

      const listaOrdenesExcel = [];

      if (this.state.fechaDesde === "") {
        this.setState({ hideSpinner: true });
        return;
      }
      if (this.state.fechaHasta === "") {
        this.setState({ hideSpinner: true });
        return;
      }

      localStorage.setItem("GestionDeLiquidacionFechaDesde", this.state.fechaDesde);
      localStorage.setItem("GestionDeLiquidacionFechaHasta", this.state.fechaHasta);

      const request = {
        fechaDesde: this.state.fechaDesde,
        fechaHasta: this.state.fechaHasta,
        idSeller: 0,
        idEstado: 0,
        buscaTodo: 1
      };

      fetchLiquidacionesBusquedaDirecto(request).then(res => {

        var objeto = res['encabezado'];

                for (var j in objeto) {
                    let cargaNovedadesExcel = {
                        seller: objeto[j]['razonSocialSeller'],
                        fecha: objeto[j]['mostrarFecha'],
                        estado: objeto[j]['tipoEstadoLiquidacionMostrar'],
                        idLiquidacion: objeto[j]['idLiquidacion'],
                        cantNovedades: objeto[j]['cantidadNovedades'],
                        cantOrdenes: objeto[j]['cantidadOrdenes'],
                        comisionNeta: objeto[j]['comisionNeta'],
                        comisionTotal: objeto[j]['comisionTotal'],
                        totalLiquidacion: objeto[j]['totalLiquidacion'],
                        TotalNovedades: objeto[j]['totalNovedades'],
                        totalOrdenes: objeto[j]['totalOrden'],
                    }
                    listaOrdenesExcel.push(cargaNovedadesExcel);
                }
            
                this.setState({
                    datosExcelFormateados: listaOrdenesExcel,
                    hideSpinner: true
                }, () => {
                    var link = null;
                    link = document.getElementById('btnDescargaExcel');

                    if (link) {
                        link.click();
                    }
                });
            }).catch(() => {
                this.setState({ datosExcelFormateados: null });
            }).finally(() => {
                this.setState({ hideSpinner: true });
            });
        }
    }

    componentDidMount() {
        localStorage.removeItem("GestionDeLiquidacionFechaDesde");
        localStorage.removeItem("GestionDeLiquidacionFechaHasta");
        localStorage.removeItem("GestionDeLiquidacionSeller");
        localStorage.removeItem("GestionDeLiquidacionEstado");

    this.props.limpiarLiquidacionesBusqueda();
    this.setState({ lista_liquidaciones_busqueda: [] });

    localStorage.setItem('GestionDeLiquidacionEstado', 2);

    let fecha = new Date();
    fecha.setDate(fecha.getDate() - 15);
    let fechaNewQuince = fecha.toISOString().slice(0, 10);

    let fechasesenta = new Date();
    fechasesenta.setDate(fechasesenta.getDate() - 60);
    let fechafechasesentafinal = fechasesenta.toISOString().slice(0, 10);

    let fechaActual = new Date();
    fechaActual.setDate(fechaActual.getDate());
    let fechaNewActual = fechaActual.toISOString().slice(0, 10);
    this.setState({
      fechaDesdesesenta: fechafechasesentafinal,
      fechaDesde: fechaNewQuince,
      fechaDesdePredeterminado: fechaNewQuince,
      fechaHasta: fechaNewActual,
      fechaHastaPredeterminado: fechaNewActual,
    });
  }

  selectSearchHandlerLiquidacionesSeller = (options) => {

    let valor = { label: options.label, value: options.value.toString() };
    this.setState({
      comboLiquidacionSeller: valor
    })
    localStorage.setItem('GestionDeLiquidacionSeller', options.value);
  }

  selectSearchHandlerLiquidacionesEstado = (options) => {

    let valor = { label: options.label, value: options.value.toString() };
    this.setState({
      comboLiquidacionEstado: valor
    })
    localStorage.setItem('GestionDeLiquidacionEstado', options.value);
  }

  mapSellers = () => {
    this.props.fetchSellersFilter({
      Descripcion: "",
      Page: 1,
      PageSize: 100
    });
  }

  onSelectSearchInputSellers = (descripcion, action) => {
    if (action.action === 'input-change') {
      this.props.fetchSellersFilter({
        Descripcion: descripcion,
        Page: 1,
        PageSize: 100
      });
    }
  }

  mapEstados = () => {
    fetchEstadosLiquidacionesCorrecto().then(res_estados => {
      let listaEstado = res_estados.listadoEstadosLiquidaciones.map((tipo, index) => {
        return { label: tipo.descripcion, value: tipo.idEstado.toString() };
      })
      this.setState({
        lista_estados_liquidaciones: listaEstado
      })
    });
  }

  render() {

    const listaSellers = Array.isArray(this.props.filteredSellers)
      ? this.props.filteredSellers.map(s => ({ label: s.label, value: s.value.toString() }))
      : [];

    let selectListaSellers = <div style={{
      position: "relative",
      left: "-15px",
      paddingBottom: "10px"
    }} className="col-lg-12">
      <p className="font-bold">
        Seller
      </p>
      <Select
        name="GestionDeLiquidacionSeller"
        id="GestionDeLiquidacionSeller"
        value={this.state.comboLiquidacionSeller}
        options={listaSellers}
        onChange={this.selectSearchHandlerLiquidacionesSeller}
        onMenuOpen={this.mapSellers}
        onInputChange={this.onSelectSearchInputSellers}
        styles={customStyleFilter}
        {...filterSelectMenuPortalProps}
        components={{ DropdownIndicator: () => DropDownArrow }}
      />
    </div>

    let selectListaEstados = <div style={{
      position: "relative",
      left: "-15px",
      paddingBottom: "10px"
    }} className="col-lg-12">
      <p className="font-bold">
        Estados
      </p>
      <Select
        name="GestionDeLiquidacionEstado"
        id="GestionDeLiquidacionEstado"
        defaultValue={{ label: "En Preparacion", value: "2" }}
        options={this.state.lista_estados_liquidaciones}
        onChange={this.selectSearchHandlerLiquidacionesEstado}
        onMenuOpen={this.mapEstados}
        styles={customStyleFilter}
        {...filterSelectMenuPortalProps}
        components={{ DropdownIndicator: () => DropDownArrow }}
      />
    </div>

    return (
      <div className="container exportables-page">
        <div className="row mb-3 mb-md-4 align-items-center py-3 px-2 rounded admin-page-heading" style={{ background: 'linear-gradient(to right, #f8f9fa 0%, #fff 100%)', borderLeft: '4px solid var(--rojo-megatone, #c00)' }}>
          <div className="col-12 col-md-7">
            <h4 className="mb-0 text-themecolor color-rojo-megatone fw-bold">Exportables - Liquidaciones</h4>
            <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
              Exportación de liquidaciones por fecha, seller y estado.
            </p>
          </div>

          <div className="col-12 col-md-3 mt-2 mt-md-0 button-group align-self-center text-md-end d-none d-md-block">
            {!this.state.hideSpinner && (
              <div className="d-flex align-items-center gap-2">
                <MiniSpinner />
                <span className="small text-muted">Buscando...</span>
              </div>
            )}
          </div>

          <div className="col-12 col-md-2 mt-2 mt-md-0 button-group text-md-end">

            <button
              type="button"
              onClick={this.busquedaParaDescargarExcel}
              className="btn btn-sm btn-green"
              disabled={!this.state.estadoCheckbox}
            >
              Descargar Excel
            </button>

            <button
              id="btnDescargaExcel"
              className="d-none"
              onClick={() => exportToExcel(
                this.state.datosExcelFormateados,
                'liquidaciones',
                'Liquidaciones'
              )}
            ></button>
          </div>
        </div>

        <div className="exportables-filter-shell">
          <div className="card card-body filter-card exportables-filter-card">
            <div className="row form-material">

              <div className="col-md-2">
                <p className="font-bold">Desde</p>
                <input
                  type="date"
                  name="fechaDesde"
                  id="GestionDeLiquidacionFechaDesde"
                  min={this.state.fechaDesdesesenta}
                  className="form-control"
                  value={this.state.fechaDesde}
                  onChange={this.myChangeHandler}
                />
              </div>

              <div className="col-md-2">
                <p className="font-bold">Hasta</p>
                <input
                  type="date"
                  name="fechaHasta"
                  id="GestionDeLiquidacionFechaHasta"
                  className="form-control"
                  value={this.state.fechaHasta}
                  onChange={this.myChangeHandler}
                />
              </div>

              <div className="col-3">
                {selectListaSellers}
              </div>

              <div className="col-3">
                {selectListaEstados}
              </div>
            </div>

                <div className="ibox-content float-e-margins">
                    <input 
                        id="BuscaTodo" 
                        type="checkbox" 
                        onChange={(e) => this.setState({estadoCheckbox: e.target.checked})} 
                    /> 
                    <label htmlFor="BuscaTodo">
                        Todas las liquidaciones de todos los sellers en el rango de tiempo
                    </label>
                </div>
            </div>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({
    lista_sellers_liquidaciones: state.sellers.lista_sellers_liquidaciones,
    filteredSellers: state.sellers.filteredSellers,
    tipoUsuario: state.general.tipoUsuario,
    lista_estados_liquidaciones: state.liquidaciones.lista_estados_liquidaciones,
    lista_liquidaciones_busqueda: state.liquidaciones.lista_liquidaciones_busqueda
});

const mapDispatchToProps = dispatch => ({
    fetchSellersFilter: bindActionCreators(fetchSellersFilter, dispatch),
    fetchEstadosLiquidaciones: bindActionCreators(fetchEstadosLiquidaciones, dispatch),
    fetchLiquidacionesBusqueda: bindActionCreators(fetchLiquidacionesBusqueda, dispatch),
    limpiarLiquidacionesBusqueda: bindActionCreators(limpiarLiquidacionesBusqueda, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ExportarLiquidaciones);
